import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
	selector: 'skl-dialog-header-ins',
	imports: [IconComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	templateUrl: './dialog-header-ins.component.html'
})
export class DialogHeaderComponentIns {
	title = input.required<string>();
	closeVisible = input<boolean>(true);
	onClose = output();

	close(): void {
		this.onClose.emit();
	}
}
